/*!
 * Video Extension for Jarallax v2.2.1 (https://github.com/nk-o/jarallax)
 * Copyright 2024 nK <https://nkdev.info>
 * Licensed under MIT (https://github.com/nk-o/jarallax/blob/master/LICENSE)
 */ !(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define(t)
    : ((e =
        "undefined" != typeof globalThis
          ? globalThis
          : e || self).jarallaxVideo = t());
})(this, function () {
  "use strict";
  let e = 0;
  class t {
    type = "none";
    constructor(e, t) {
      let i = this;
      (i.url = e),
        (i.options_default = {
          autoplay: !1,
          loop: !1,
          mute: !1,
          volume: 100,
          showControls: !0,
          accessibilityHidden: !1,
          startTime: 0,
          endTime: 0,
        }),
        (i.options = (function e(t, ...i) {
          return (
            (t = t || {}),
            Object.keys(i).forEach((e) => {
              i[e] &&
                Object.keys(i[e]).forEach((o) => {
                  t[o] = i[e][o];
                });
            }),
            t
          );
        })({}, i.options_default, t)),
        (i.videoID = i.constructor.parseURL(e)),
        i.videoID && i.init();
    }
    isValid() {
      return !!this.videoID;
    }
    init() {
      let t = this;
      (t.ID = e), (e += 1), (t.playerID = `VideoWorker-${t.ID}`);
    }
    on(e, t) {
      (this.userEventsList = this.userEventsList || []),
        (this.userEventsList[e] || (this.userEventsList[e] = [])).push(t);
    }
    off(e, t) {
      this.userEventsList &&
        this.userEventsList[e] &&
        (t
          ? this.userEventsList[e].forEach((i, o) => {
              i === t && (this.userEventsList[e][o] = !1);
            })
          : delete this.userEventsList[e]);
    }
    fire(e, ...t) {
      this.userEventsList &&
        void 0 !== this.userEventsList[e] &&
        this.userEventsList[e].forEach((e) => {
          e && e.apply(this, t);
        });
    }
    static parseURL(e) {
      return !1;
    }
    play(e) {}
    pause() {}
    mute() {}
    unmute() {}
    setVolume(e = !1) {}
    getVolume(e) {}
    getMuted(e) {}
    setCurrentTime(e = !1) {}
    getCurrentTime(e) {}
    getImageURL(e) {}
    getVideo(e) {}
  }
  let i;
  var o,
    a = (i =
      "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
        ? self
        : {});
  function r() {
    (this.doneCallbacks = []), (this.failCallbacks = []);
  }
  r.prototype = {
    execute(e, t) {
      let i = e.length;
      for (t = Array.prototype.slice.call(t); i; ) e[(i -= 1)].apply(null, t);
    },
    resolve(...e) {
      this.execute(this.doneCallbacks, e);
    },
    reject(...e) {
      this.execute(this.failCallbacks, e);
    },
    done(e) {
      this.doneCallbacks.push(e);
    },
    fail(e) {
      this.failCallbacks.push(e);
    },
  };
  let s = 0,
    l = 0,
    n = new r(),
    p = 0,
    d = 0,
    u = new r();
  function m(e, i) {
    let o = !1;
    return (
      Object.keys(m.providers).forEach((t) => {
        !o && m.providers[t].parseURL(e) && (o = new m.providers[t](e, i));
      }),
      o || new t(e, i)
    );
  }
  (m.BaseClass = t),
    (m.providers = {
      Youtube: class e extends t {
        type = "youtube";
        static parseURL(e) {
          let t = e.match(
            /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|shorts\/|watch\?v=)([^#\&\?]*).*/
          );
          return !!t && 11 === t[1].length && t[1];
        }
        init() {
          super.init(),
            (function e() {
              if (s) return;
              s = !0;
              let t = document.createElement("script"),
                i = document.getElementsByTagName("head")[0];
              (t.src = "https://www.youtube.com/iframe_api"),
                i.appendChild(t),
                (i = null),
                (t = null);
            })();
        }
        play(e) {
          let t = this;
          t.player &&
            t.player.playVideo &&
            (void 0 !== e && t.player.seekTo(e || 0),
            a.YT.PlayerState.PLAYING !== t.player.getPlayerState() &&
              (t.options.endTime && !t.options.loop
                ? t.getCurrentTime((e) => {
                    e < t.options.endTime && t.player.playVideo();
                  })
                : t.player.playVideo()));
        }
        pause() {
          this.player &&
            this.player.pauseVideo &&
            a.YT.PlayerState.PLAYING === this.player.getPlayerState() &&
            this.player.pauseVideo();
        }
        mute() {
          this.player && this.player.mute && this.player.mute();
        }
        unmute() {
          this.player && this.player.unMute && this.player.unMute();
        }
        setVolume(e = !1) {
          this.player &&
            "number" == typeof e &&
            this.player.setVolume &&
            this.player.setVolume(e);
        }
        getVolume(e) {
          if (!this.player) {
            e(!1);
            return;
          }
          this.player.getVolume && e(this.player.getVolume());
        }
        getMuted(e) {
          if (!this.player) {
            e(null);
            return;
          }
          this.player.isMuted && e(this.player.isMuted());
        }
        setCurrentTime(e = !1) {
          this.player &&
            "number" == typeof e &&
            this.player.seekTo &&
            this.player.seekTo(e);
        }
        getCurrentTime(e) {
          this.player &&
            this.player.getCurrentTime &&
            e(this.player.getCurrentTime());
        }
        getImageURL(e) {
          let t = this;
          if (t.videoImage) {
            e(t.videoImage);
            return;
          }
          let i = ["maxresdefault", "sddefault", "hqdefault", "0"],
            o = 0,
            a = new Image();
          (a.onload = function () {
            120 !== (this.naturalWidth || this.width) || o === i.length - 1
              ? ((t.videoImage = `https://img.youtube.com/vi/${t.videoID}/${i[o]}.jpg`),
                e(t.videoImage))
              : ((o += 1),
                (this.src = `https://img.youtube.com/vi/${t.videoID}/${i[o]}.jpg`));
          }),
            (a.src = `https://img.youtube.com/vi/${t.videoID}/${i[o]}.jpg`);
        }
        getVideo(e) {
          var t;
          let i = this;
          if (i.$video) {
            e(i.$video);
            return;
          }
          (t = () => {
            let t;
            i.$video ||
              ((t = document.createElement("div")).style.display = "none"),
              (i.playerOptions = {
                host: "https://www.youtube-nocookie.com",
                videoId: i.videoID,
                playerVars: {
                  autohide: 1,
                  rel: 0,
                  autoplay: 0,
                  playsinline: 1,
                },
              }),
              i.options.showControls ||
                ((i.playerOptions.playerVars.iv_load_policy = 3),
                (i.playerOptions.playerVars.modestbranding = 1),
                (i.playerOptions.playerVars.controls = 0),
                (i.playerOptions.playerVars.showinfo = 0),
                (i.playerOptions.playerVars.disablekb = 1));
            let o, r;
            i.playerOptions.events = {
              onReady(e) {
                i.options.mute
                  ? e.target.mute()
                  : "number" == typeof i.options.volume &&
                    e.target.setVolume(i.options.volume),
                  i.options.autoplay && i.play(i.options.startTime),
                  i.fire("ready", e),
                  i.options.loop &&
                    !i.options.endTime &&
                    (i.options.endTime = i.player.getDuration() - 0.1),
                  setInterval(() => {
                    i.getVolume((t) => {
                      i.options.volume !== t &&
                        ((i.options.volume = t), i.fire("volumechange", e));
                    });
                  }, 150);
              },
              onStateChange(e) {
                i.options.loop &&
                  e.data === a.YT.PlayerState.ENDED &&
                  i.play(i.options.startTime),
                  o ||
                    e.data !== a.YT.PlayerState.PLAYING ||
                    ((o = 1), i.fire("started", e)),
                  e.data === a.YT.PlayerState.PLAYING && i.fire("play", e),
                  e.data === a.YT.PlayerState.PAUSED && i.fire("pause", e),
                  e.data === a.YT.PlayerState.ENDED && i.fire("ended", e),
                  e.data === a.YT.PlayerState.PLAYING
                    ? (r = setInterval(() => {
                        i.fire("timeupdate", e),
                          i.options.endTime &&
                            i.player.getCurrentTime() >= i.options.endTime &&
                            (i.options.loop
                              ? i.play(i.options.startTime)
                              : i.pause());
                      }, 150))
                    : clearInterval(r);
              },
              onError(e) {
                i.fire("error", e);
              },
            };
            let s = !i.$video;
            if (s) {
              let l = document.createElement("div");
              l.setAttribute("id", i.playerID),
                t.appendChild(l),
                document.body.appendChild(t);
            }
            (i.player =
              i.player || new a.YT.Player(i.playerID, i.playerOptions)),
              s &&
                ((i.$video = document.getElementById(i.playerID)),
                i.options.accessibilityHidden &&
                  (i.$video.setAttribute("tabindex", "-1"),
                  i.$video.setAttribute("aria-hidden", "true")),
                (i.videoWidth =
                  parseInt(i.$video.getAttribute("width"), 10) || 1280),
                (i.videoHeight =
                  parseInt(i.$video.getAttribute("height"), 10) || 720)),
              e(i.$video);
          }),
            (void 0 !== a.YT && 0 !== a.YT.loaded) || l
              ? "object" == typeof a.YT && 1 === a.YT.loaded
                ? t()
                : n.done(() => {
                    t();
                  })
              : ((l = 1),
                (a.onYouTubeIframeAPIReady = function () {
                  (a.onYouTubeIframeAPIReady = null), n.resolve("done"), t();
                }));
        }
      },
      Vimeo: class e extends t {
        type = "vimeo";
        static parseURL(e) {
          let t = e.match(
            /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/
          );
          return !!t && !!t[3] && t[3];
        }
        static parseURLHash(e) {
          let t = e.match(
            /^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/
          );
          return t && 5 === t.length ? t[4] : null;
        }
        init() {
          super.init(),
            (function e() {
              if (p || ((p = !0), void 0 !== a.Vimeo)) return;
              let t = document.createElement("script"),
                i = document.getElementsByTagName("head")[0];
              (t.src = "https://player.vimeo.com/api/player.js"),
                i.appendChild(t),
                (i = null),
                (t = null);
            })();
        }
        play(e) {
          let t = this;
          t.player &&
            (void 0 !== e && t.player.setCurrentTime(e),
            t.player.getPaused().then((e) => {
              e &&
                (t.options.endTime && !t.options.loop
                  ? t.getCurrentTime((e) => {
                      e < t.options.endTime && t.player.play();
                    })
                  : t.player.play());
            }));
        }
        pause() {
          let e = this;
          e.player &&
            e.player.getPaused().then((t) => {
              t || e.player.pause();
            });
        }
        mute() {
          this.player && this.player.setVolume && this.setVolume(0);
        }
        unmute() {
          this.player &&
            this.player.setVolume &&
            this.setVolume(this.options.volume || 100);
        }
        setVolume(e = !1) {
          this.player &&
            "number" == typeof e &&
            this.player.setVolume &&
            this.player.setVolume(e / 100);
        }
        getVolume(e) {
          if (!this.player) {
            e(!1);
            return;
          }
          this.player.getVolume &&
            this.player.getVolume().then((t) => {
              e(100 * t);
            });
        }
        getMuted(e) {
          if (!this.player) {
            e(null);
            return;
          }
          this.player.getVolume &&
            this.player.getVolume().then((t) => {
              e(!!t);
            });
        }
        setCurrentTime(e = !1) {
          this.player &&
            "number" == typeof e &&
            this.player.setCurrentTime &&
            this.player.setCurrentTime(e);
        }
        getCurrentTime(e) {
          this.player &&
            this.player.getCurrentTime &&
            this.player.getCurrentTime().then((t) => {
              e(t);
            });
        }
        getImageURL(e) {
          let t = this;
          if (t.videoImage) {
            e(t.videoImage);
            return;
          }
          let i = a.innerWidth || 1920;
          a.devicePixelRatio && (i *= a.devicePixelRatio),
            (i = Math.min(i, 1920));
          let o = new XMLHttpRequest();
          o.open(
            "GET",
            `https://vimeo.com/api/oembed.json?url=${t.url}&width=${i}`,
            !0
          ),
            (o.onreadystatechange = function () {
              if (
                4 === this.readyState &&
                this.status >= 200 &&
                this.status < 400
              ) {
                let i = JSON.parse(this.responseText);
                i.thumbnail_url &&
                  ((t.videoImage = i.thumbnail_url), e(t.videoImage));
              }
            }),
            o.send(),
            (o = null);
        }
        getVideo(e) {
          let t = this;
          if (t.$video) {
            e(t.$video);
            return;
          }
          !(function e(t) {
            if (void 0 !== a.Vimeo || d)
              void 0 !== a.Vimeo
                ? t()
                : u.done(() => {
                    t();
                  });
            else {
              d = 1;
              let i = setInterval(() => {
                void 0 !== a.Vimeo &&
                  (clearInterval(i), u.resolve("done"), t());
              }, 20);
            }
          })(() => {
            let i;
            t.$video ||
              ((i = document.createElement("div")).style.display = "none"),
              (t.playerOptions = {
                dnt: 1,
                id: t.videoID,
                autopause: 0,
                transparent: 0,
                autoplay: t.options.autoplay ? 1 : 0,
                loop: t.options.loop ? 1 : 0,
                muted: t.options.mute || 0 === t.options.volume ? 1 : 0,
              });
            let o = t.constructor.parseURLHash(t.url);
            if (
              (o && (t.playerOptions.h = o),
              t.options.showControls || (t.playerOptions.controls = 0),
              !t.options.showControls &&
                t.options.loop &&
                t.options.autoplay &&
                (t.playerOptions.background = 1),
              !t.$video)
            ) {
              let r = "";
              Object.keys(t.playerOptions).forEach((e) => {
                "" !== r && (r += "&"),
                  (r += `${e}=${encodeURIComponent(t.playerOptions[e])}`);
              }),
                (t.$video = document.createElement("iframe")),
                t.$video.setAttribute("id", t.playerID),
                t.$video.setAttribute(
                  "src",
                  `https://player.vimeo.com/video/${t.videoID}?${r}`
                ),
                t.$video.setAttribute("frameborder", "0"),
                t.$video.setAttribute("mozallowfullscreen", ""),
                t.$video.setAttribute("allowfullscreen", ""),
                t.$video.setAttribute("title", "Vimeo video player"),
                t.options.accessibilityHidden &&
                  (t.$video.setAttribute("tabindex", "-1"),
                  t.$video.setAttribute("aria-hidden", "true")),
                i.appendChild(t.$video),
                document.body.appendChild(i);
            }
            (t.player =
              t.player || new a.Vimeo.Player(t.$video, t.playerOptions)),
              t.options.mute ||
                "number" != typeof t.options.volume ||
                t.setVolume(t.options.volume),
              t.options.startTime &&
                t.options.autoplay &&
                t.player.setCurrentTime(t.options.startTime),
              t.player.getVideoWidth().then((e) => {
                t.videoWidth = e || 1280;
              }),
              t.player.getVideoHeight().then((e) => {
                t.videoHeight = e || 720;
              });
            let s;
            t.player.on("timeupdate", (e) => {
              s || (t.fire("started", e), (s = 1)),
                t.fire("timeupdate", e),
                t.options.endTime &&
                  e.seconds >= t.options.endTime &&
                  (t.options.loop ? t.play(t.options.startTime) : t.pause());
            }),
              t.player.on("play", (e) => {
                t.fire("play", e),
                  t.options.startTime &&
                    0 === e.seconds &&
                    t.play(t.options.startTime);
              }),
              t.player.on("pause", (e) => {
                t.fire("pause", e);
              }),
              t.player.on("ended", (e) => {
                t.fire("ended", e);
              }),
              t.player.on("loaded", (e) => {
                t.fire("ready", e);
              }),
              t.player.on("volumechange", (e) => {
                t.getVolume((e) => {
                  t.options.volume = e;
                }),
                  t.fire("volumechange", e);
              }),
              t.player.on("error", (e) => {
                t.fire("error", e);
              }),
              e(t.$video);
          });
        }
      },
      Local: class e extends t {
        type = "local";
        static parseURL(e) {
          let t = e.split(/,(?=mp4\:|webm\:|ogv\:|ogg\:)/),
            i = {},
            o = 0;
          return (
            t.forEach((e) => {
              let t = e.match(/^(mp4|webm|ogv|ogg)\:(.*)/);
              t &&
                t[1] &&
                t[2] &&
                ((i["ogv" === t[1] ? "ogg" : t[1]] = t[2]), (o = 1));
            }),
            !!o && i
          );
        }
        play(e) {
          let t = this;
          t.player &&
            (void 0 !== e && (t.player.currentTime = e),
            t.player.paused &&
              (t.options.endTime && !t.options.loop
                ? t.getCurrentTime((e) => {
                    e < t.options.endTime && t.player.play();
                  })
                : t.player.play()));
        }
        pause() {
          this.player && !this.player.paused && this.player.pause();
        }
        mute() {
          let e = this;
          e.player && (e.$video.muted = !0);
        }
        unmute() {
          let e = this;
          e.player && (e.$video.muted = !1);
        }
        setVolume(e = !1) {
          let t = this;
          t.player && "number" == typeof e && (t.$video.volume = e / 100);
        }
        getVolume(e) {
          if (!this.player) {
            e(!1);
            return;
          }
          e(100 * this.$video.volume);
        }
        getMuted(e) {
          if (!this.player) {
            e(null);
            return;
          }
          e(this.$video.muted);
        }
        setCurrentTime(e = !1) {
          let t = this;
          t.player && "number" == typeof e && (t.$video.currentTime = e);
        }
        getCurrentTime(e) {
          this.player && e(this.player.currentTime);
        }
        getImageURL(e) {
          this.videoImage && e(this.videoImage);
        }
        getVideo(e) {
          let t = this;
          if (t.$video) {
            e(t.$video);
            return;
          }
          let i;
          t.$video ||
            ((i = document.createElement("div")).style.display = "none"),
            t.$video ||
              ((t.$video = document.createElement("video")),
              (t.player = t.$video),
              t.options.showControls && (t.$video.controls = !0),
              "number" == typeof t.options.volume &&
                t.setVolume(t.options.volume),
              t.options.mute && t.mute(),
              t.options.loop && (t.$video.loop = !0),
              t.$video.setAttribute("playsinline", ""),
              t.$video.setAttribute("webkit-playsinline", ""),
              t.options.accessibilityHidden &&
                (t.$video.setAttribute("tabindex", "-1"),
                t.$video.setAttribute("aria-hidden", "true")),
              t.$video.setAttribute("id", t.playerID),
              i.appendChild(t.$video),
              document.body.appendChild(i),
              Object.keys(t.videoID).forEach((e) => {
                !(function e(t, i, o) {
                  let a = document.createElement("source");
                  (a.src = i), (a.type = o), t.appendChild(a);
                })(t.$video, t.videoID[e], `video/${e}`);
              }));
          let o;
          t.player.addEventListener("playing", (e) => {
            o || t.fire("started", e), (o = 1);
          }),
            t.player.addEventListener("timeupdate", function (e) {
              t.fire("timeupdate", e),
                t.options.endTime &&
                  this.currentTime >= t.options.endTime &&
                  (t.options.loop ? t.play(t.options.startTime) : t.pause());
            }),
            t.player.addEventListener("play", (e) => {
              t.fire("play", e);
            }),
            t.player.addEventListener("pause", (e) => {
              t.fire("pause", e);
            }),
            t.player.addEventListener("ended", (e) => {
              t.fire("ended", e);
            }),
            t.player.addEventListener("loadedmetadata", function () {
              (t.videoWidth = this.videoWidth || 1280),
                (t.videoHeight = this.videoHeight || 720),
                t.fire("ready"),
                t.options.autoplay && t.play(t.options.startTime);
            }),
            t.player.addEventListener("volumechange", (e) => {
              t.getVolume((e) => {
                t.options.volume = e;
              }),
                t.fire("volumechange", e);
            }),
            t.player.addEventListener("error", (e) => {
              t.fire("error", e);
            }),
            e(t.$video);
        }
      },
    });
  let y;
  var h = (y =
    "undefined" != typeof window
      ? window
      : "undefined" != typeof global
      ? global
      : "undefined" != typeof self
      ? self
      : {});
  function v(e = h.jarallax) {
    if (void 0 === e) return;
    let t = e.constructor,
      i = t.prototype.onScroll;
    t.prototype.onScroll = function () {
      let e = this;
      i.apply(e);
      let t =
        !e.isVideoInserted &&
        e.video &&
        (!e.options.videoLazyLoading || e.isElementInViewport) &&
        !e.options.disableVideo();
      t &&
        ((e.isVideoInserted = !0),
        e.video.getVideo((t) => {
          let i = t.parentNode;
          e.css(t, {
            position: e.image.position,
            top: "0px",
            left: "0px",
            right: "0px",
            bottom: "0px",
            width: "100%",
            height: "100%",
            maxWidth: "none",
            maxHeight: "none",
            pointerEvents: "none",
            transformStyle: "preserve-3d",
            backfaceVisibility: "hidden",
            margin: 0,
            zIndex: -1,
          }),
            (e.$video = t),
            "local" === e.video.type &&
              (e.image.src
                ? e.$video.setAttribute("poster", e.image.src)
                : e.image.$item &&
                  "IMG" === e.image.$item.tagName &&
                  e.image.$item.src &&
                  e.$video.setAttribute("poster", e.image.$item.src)),
            e.options.videoClass &&
              e.$video.setAttribute(
                "class",
                `${e.options.videoClass} ${e.options.videoClass}-${e.video.type}`
              ),
            e.image.$container.appendChild(t),
            i.parentNode.removeChild(i),
            e.options.onVideoInsert && e.options.onVideoInsert.call(e);
        }));
    };
    let o = t.prototype.coverImage;
    t.prototype.coverImage = function () {
      let e = o.apply(this),
        t = !!this.image.$item && this.image.$item.nodeName;
      if (e && this.video && t && ("IFRAME" === t || "VIDEO" === t)) {
        let i = e.image.height,
          a = (i * this.image.width) / this.image.height,
          r = (e.container.width - a) / 2,
          s = e.image.marginTop;
        e.container.width > a &&
          ((i =
            ((a = e.container.width) * this.image.height) / this.image.width),
          (r = 0),
          (s += (e.image.height - i) / 2)),
          "IFRAME" === t && ((i += 400), (s -= 200)),
          this.css(this.$video, {
            width: `${a}px`,
            marginLeft: `${r}px`,
            height: `${i}px`,
            marginTop: `${s}px`,
          });
      }
      return e;
    };
    let a = t.prototype.initImg;
    t.prototype.initImg = function () {
      let e = this,
        t = a.apply(e);
      return (e.options.videoSrc ||
        (e.options.videoSrc =
          e.$item.getAttribute("data-jarallax-video") || null),
      e.options.videoSrc)
        ? ((e.defaultInitImgResult = t), !0)
        : t;
    };
    let r = t.prototype.canInitParallax;
    t.prototype.canInitParallax = function () {
      let e = this,
        t = r.apply(e);
      if (!e.options.videoSrc) return t;
      let i = new m(e.options.videoSrc, {
        autoplay: !0,
        loop: e.options.videoLoop,
        showControls: !1,
        accessibilityHidden: !0,
        startTime: e.options.videoStartTime || 0,
        endTime: e.options.videoEndTime || 0,
        mute: !e.options.videoVolume,
        volume: e.options.videoVolume || 0,
      });
      function o() {
        e.image.$default_item &&
          ((e.image.$item = e.image.$default_item),
          (e.image.$item.style.display = "block"),
          e.coverImage(),
          e.onScroll());
      }
      if (
        (e.options.onVideoWorkerInit && e.options.onVideoWorkerInit.call(e, i),
        i.isValid())
      ) {
        if (
          (this.options.disableParallax() &&
            ((t = !0),
            (e.image.position = "absolute"),
            (e.options.type = "scroll"),
            (e.options.speed = 1)),
          t)
        ) {
          if (
            (i.on("ready", () => {
              if (e.options.videoPlayOnlyVisible) {
                let t = e.onScroll;
                e.onScroll = function () {
                  t.apply(e),
                    e.videoError ||
                      (!e.options.videoLoop &&
                        (e.options.videoLoop || e.videoEnded)) ||
                      (e.isVisible() ? i.play() : i.pause());
                };
              } else i.play();
            }),
            i.on("started", () => {
              (e.image.$default_item = e.image.$item),
                (e.image.$item = e.$video),
                (e.image.width = e.video.videoWidth || 1280),
                (e.image.height = e.video.videoHeight || 720),
                e.coverImage(),
                e.onScroll(),
                e.image.$default_item &&
                  (e.image.$default_item.style.display = "none");
            }),
            i.on("ended", () => {
              (e.videoEnded = !0), e.options.videoLoop || o();
            }),
            i.on("error", () => {
              (e.videoError = !0), o();
            }),
            (e.video = i),
            !e.defaultInitImgResult &&
              ((e.image.src =
                "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"),
              "local" !== i.type))
          )
            return (
              i.getImageURL((t) => {
                (e.image.bgImage = `url("${t}")`), e.init();
              }),
              !1
            );
        } else
          e.defaultInitImgResult ||
            i.getImageURL((t) => {
              let i = e.$item.getAttribute("style");
              i && e.$item.setAttribute("data-jarallax-original-styles", i),
                e.css(e.$item, {
                  "background-image": `url("${t}")`,
                  "background-position": "center",
                  "background-size": "cover",
                });
            });
      }
      return t;
    };
    let s = t.prototype.destroy;
    t.prototype.destroy = function () {
      let e = this;
      e.image.$default_item &&
        ((e.image.$item = e.image.$default_item), delete e.image.$default_item),
        s.apply(e);
    };
  }
  return (
    v(),
    (o = () => {
      void 0 !== h.jarallax &&
        h.jarallax(document.querySelectorAll("[data-jarallax-video]"));
    }),
    "complete" === document.readyState || "interactive" === document.readyState
      ? o()
      : document.addEventListener("DOMContentLoaded", o, {
          capture: !0,
          once: !0,
          passive: !0,
        }),
    h.VideoWorker || (h.VideoWorker = m),
    v
  );
});
